export default "__VITE_ASSET__D4wLz$dW__"